import { useEffect, useState, useMemo } from "react";
//--------------------------------------------------------------------------------------------
import Modal from "src/components/common/modal";
import { useMyStore } from "src/components/main/mainStore";
import { myAxios, MyDate, MyFormData, Select } from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export const Allitems = [
    {title: "Spare Med Gloves", qty: 2},
    {title: "Spare Lrg Gloves", qty: 2},
    {title: "Spare X-Lrg Gloves", qty: 2},
    {title: "Box Ear Plugs", qty: 1},
    {title: "Spare safety glasses", qty: 2},
    {title: "Safety glasses strap", qty: 2},
    {title: "Wheel Chock Set", qty: 1},
    {title: "Manhole Hook", qty: 1},
    {title: "Cones", qty: 2},
    {title: "Fire Extinguisher", qty: 1, needtoCheck: true},
    {title: "First Aid Kit", qty: 1, needtoCheck: true},
    {title: "Eye wash", qty: 1, needtoCheck: true},
];
export default function TrailerForm({
    preOrPost, 
    closeIt,
    setWorkLogs, 
    /*---- workLog ------------------------------------------------*/
    workLogHashKey, 
    trailerStr, 
    userName
    /*-------------------------------------------------------------*/
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    // workLog: userName, preTrailer, postTrailer, workLogHashKey
    const TRLitems = [
        {title: "44\" Pipe Wrench", qty: 1},
        {title: "Crescent Wrench 18\"", qty: 1},
        {title: "Cheater Bar", qty: 1},
        {title: "Screw Driver Long Flat", qty: 1},
        {title: "Grease Gun 10K PSI", qty: 1, needtoCheck: true}
    ]
    const HPitems = [
        {title: "Hand saw 14\" Steel Skeel", qty: 1},
        {title: "Cement Blade/Asphalt Combo blade", qty: 1},
        {title: "Vibrator Plate", qty: 1},
        {title: "Rake", qty: 1},
        {title: "Flat Shovel", qty: 2},
        {title: "Broom", qty: 1},
        {title: "Mounted Fire Extinguisher", qty: 1},
        {title: "Wheel Chocks (set of 2)", qty: 1},
        {title: "Permanent License Plate", qty: 1},
    ]
    const [data, setData] = useState(
        trailerStr?
        (
            JSON.parse(trailerStr).checkList?
            JSON.parse(trailerStr):
            {...JSON.parse(trailerStr), checkList: []}
        )
        :
        {trailer: "", content: [], checkList: []}
    );
 
    const list = useMemo(() => data.trailer === "hp"?[
        <>I verified security of all tools and equipment loaded on trailer, there are no loose items on trailer.</>,
        /*hot patch*/<>I verified propane level and function of heating system for hot asphalt, the trailer heats the asphalt and contains enough propane for the day</>,
        <>I verified tire condition, if low please submit equipment incident report, the tires are all safe to drive on.</>,
        <>I verified security of trailer hitch, including locking pin and chains are installed and secure, the trailer is fully and safely hooked up to the truck.</>,
        /*hot patch*/<>I verified unit is emptied at the end of the workday if not scheduled for next day use. This way the asphalt does not dry in the unit.</>,
        <>I verified that the trailer brake control in the vehicle works with the trailer, the trailer brake controller works properly.</>,
        <>I verified that all the lights/brake lights/turn signals work properly. All lights and turn signals work properly.</>,
        <>I will notify supervisor and management if there is any damage, or safety concern with equipment by completing a equipment incident form.</>,
        <>I will leave equipment clean and ready for the next day's work.</>, 
        <>I verify that the vehicle I am driving has a pair of serviceable wheel chocks prior to departure</>
    ]:[
        <>I verified security of all tools and equipment loaded on trailer, there are no loose items on trailer.</>,
        <>I verified tire condition, if low please submit equipment incident report, the tires are all safe to drive on.</>,
        <>I verified security of trailer hitch, including locking pin and chains are installed and secure, the trailer is fully and safely hooked up to the truck.</>,
        <>I verified that the trailer brake control in the vehicle works with the trailer, the trailer brake controller works properly.</>,
        <>I verified that all the lights/brake lights/turn signals work properly. All lights and turn signals work properly.</>,
        <>I will notify supervisor and management if there is any damage, or safety concern with equipment by completing a equipment incident form.</>,
        <>I will leave equipment clean and ready for the next day's work.</>, 
        <>I verify that the vehicle I am driving has a pair of serviceable wheel chocks prior to departure</>
    ], [data.trailer]);
    const [trailers, setTrailers] = useState([]);
    //--------------------------------------------------------------------------------------------
    const handleFormSubmit = async e => {
        if(data.isTrailer === true && !data.trailerNumber){
            window.alert("Please select trailer first.");
            return;
        }
        if(data.isTrailer === true && data.checkList.some(v => v === false)){
            window.alert("Please submit a vehicle damage report after submit this form.");
        }
        e.preventDefault();
        
        const formData = new MyFormData(e.currentTarget);
        formData.append("preOrPost", preOrPost);
        formData.append("workLogHashKey", workLogHashKey);
        formData.append("trailer", JSON.stringify({
            ...data, 
            submitTime: (new MyDate()).ss(),
            submitDate: (new MyDate()).s()
        }));
        //---------------------------------------------------
        setShowLoader(true);
        const vehicleFormRes = await myAxios("workLogs/trailerForm.php", formData);
        if(!vehicleFormRes) return;
        setShowLoader(false);
        //---------------------------------------------------
        setWorkLogs(workLogs => workLogs.map(w => ({
            ...w, [preOrPost + "Trailer"]:(
                w.workLogHashKey === workLogHashKey?
                vehicleFormRes.data.trailer:
                w[preOrPost + "Trailer"]
            )
            // , [preOrPost + "TrailerForeignKey"]:(
            //     w.workLogHashKey === workLogHashKey?
            //     formData.get("foreignKey"):
            //     w[preOrPost + "TrailerForeignKey"]
            // )
        })));
        closeIt();
    }
    useEffect(() => {
        setData(data => ({...data, checkList: Array(list.length).fill(false)}));
    }, [list])
    useEffect(() => {
        let isMounted = true;
        const getData = async() => {
            setShowLoader(true);
            const res = await myAxios("common/readTrailersOnly.php");
            setTrailers(res.data);
            if(!isMounted) return;
            setShowLoader(false);
        }
        getData();
        return () => {isMounted = false;}
    }, []);
    //--------------------------------------------------------------------------------------------
    return(
        <Modal
            closeIt = {closeIt}
            title = "TRAILER INSPECTION FORM"
            width = {800}
            maxWidth = {"100%"}
            handleFormSubmit = {handleFormSubmit}
            actionKey = "Submit"
        >
            {trailerStr?<div className = "my-2">submitted on {JSON.parse(trailerStr).submitDate} {JSON.parse(trailerStr).submitTime}</div>:<></>}
            <div className = "blk5 my-2" style = {{display: "flex"}}>
                <div className = "font-weight-bold mr-3">Do you tow a trailer?</div>
                <label
                    className = "mr-2"
                    htmlFor = {`isTrialerYes`}
                >
                    Yes
                </label>
                <input
                    type = "radio"
                    required = {true}
                    id = {`isTrialerYes`}
                    name = {`isTrialer`}
                    checked = {data.isTrailer === true}
                    value = "Yes"
                    onChange = {() => {
                        setData(data => ({...data, isTrailer: true}));
                    }}
                    className = "mr-3"
                    style = {{
                        width: 28, 
                        height: 28, 
                        verticalAlign: "middle", 
                        flexShrink: 0
                    }}
                />
                <label
                    className = "mr-2"
                    htmlFor = {`isTrialerNo`}
                >
                    No
                </label>
                <input
                    type = "radio"
                    required = {true}
                    id = {`isTrialerNo`}
                    name = {`isTrialer`}
                    checked = {data.isTrailer === false}
                    value = "No"
                    onChange = {() => {
                        setData({...data, isTrailer: false});
                    }}
                    className = ""
                    style = {{
                        width: 28, 
                        height: 28, 
                        verticalAlign: "middle", 
                        flexShrink: 0
                    }}
                />
            </div>
            {data.isTrailer?
            <>
            <div>                
                <div className = "blk5 mb-2" style = {{display: "flex"}}>
                    <label
                        htmlFor = {`trailerNumber`}
                        className = "font-weight-bold mr-2"
                    >
                        Trailer:
                    </label>
                    <span style = {{width: "100%"}}>
                        <Select
                            className = "mr-3"
                            required
                            value = {trailers.map(trailer => ({
                                ...trailer,
                                label: trailer.truckNumber,
                                value: trailer.truckNumber
                            })).filter(trailer => trailer.truckNumber === data.trailerNumber)}
                            onChange = {e => {
                                const items = e?.trailer === "hp"?
                                HPitems:
                                (e?.trailer === "t"?TRLitems:[]);
                                setData(data => ({
                                    ...data, 
                                    trailer: e?.trailer, 
                                    trailerNumber: e?.value,
                                    content: items
                                }));
                            }}
                            options = {trailers.map(trailer => ({
                                ...trailer,
                                label: trailer.truckNumber,
                                value: trailer.truckNumber
                            }))}
                        />
                    </span>
                </div>
                {data.content.length?
                <div>
                    <div className = "h4 mt-3 mb-2">Inventory Count:</div>
                    {data.content.map((item, itemIndex) =>
                    <li key = {itemIndex} className = "mb-2">
                        <label className = "mr-2 inline" htmlFor = {"inventory item " + itemIndex}>
                            {item.title} <span className = "text-info">{item.qty}</span>
                        </label>
                        <input
                            type = "number"
                            required
                            step = {1}
                            //max = {item.qty}
                            min = {0}
                            style = {{maxWidth: 100}}
                            className = "form-control inline mr-2"
                            id = {"inventory item " + itemIndex}
                            value = {data.content[itemIndex].value || ""}
                            onKeyDown = {(e) => ['e','.'].includes(e.key) && e.preventDefault()}
                            onBlur = {e => {
                                let value = e.currentTarget.value;
                                while(value.startsWith("0") && value.length > 1) value = value.slice(1);
                                setData({...data,
                                    content: [...data.content.slice(0, itemIndex), 
                                    {
                                        ...data.content[itemIndex], 
                                        value: value
                                    },
                                    ...data.content.slice(itemIndex + 1)]
                                });
                            }}
                            onChange = {e => {
                                setData({...data,
                                    content: [...data.content.slice(0, itemIndex), 
                                    {
                                        ...data.content[itemIndex], 
                                        value: e.currentTarget.value
                                    },
                                    ...data.content.slice(itemIndex + 1)]
                                });
                            }}
                        />
                        <span className = {"font-weight-bold " + (data.content[itemIndex].qty < window.parseInt(data.content[itemIndex].value || data.content[itemIndex].qty)?"text-success": "text-danger")}>
                            {data.content[itemIndex].qty === window.parseInt(data.content[itemIndex].value || data.content[itemIndex].qty)?
                                ""
                                :
                                (
                                    data.content[itemIndex].qty < window.parseInt(data.content[itemIndex].value || data.content[itemIndex].qty)?
                                    "+" + (window.parseInt(data.content[itemIndex].value || data.content[itemIndex].qty) - data.content[itemIndex].qty)
                                    :
                                    window.parseInt(data.content[itemIndex].value || data.content[itemIndex].qty) - data.content[itemIndex].qty
                                )
                            }
                        </span>
                    </li>)}
                </div>:null}
                {data.trailer?
                <div>
                    <div className = "h4 mt-3 mb-2">Inspection Criteria:</div>
                    {list.map((item, itemIndex) =>
                    <li key = {itemIndex} className = "mb-2">
                        <label className = "mr-2 inline" htmlFor = {"item " + itemIndex}>{item}</label>
                        <input
                            type = "checkbox"
                            style = {{
                                minWidth: 28, minHeight: 28, 
                                verticalAlign: "middle"
                            }}
                            id = {"item " + itemIndex}
                            checked = {data.checkList[itemIndex] ?? false}
                            onChange = {e => {
                                const checked = e.currentTarget.checked;
                                setData(data => ({
                                    ...data,
                                    checkList: [
                                    ...data.checkList.slice(0, itemIndex), 
                                    checked,
                                    ...data.checkList.slice(itemIndex + 1)
                                ]}));
                            }}
                        />
                    </li>)}
                </div>:null}
            </div>
            </>:null}
            <div className = "blk5 mb-2" style = {{display: "flex"}}>
                <label className = "required-field mr-3">Member name:</label>
                <input
                    type = "text" 
                    className = "form-control mr-3" 
                    readOnly
                    name = "memberName"
                    value = {userName || user.userName} 
                />
                <label className = "required-field mr-3">Date:</label>
                <input
                    type = "text"
                    className = "form-control mr-3 w-100"
                    readOnly
                    name = "submitDate" 
                    value = {(new MyDate()).s()}
                />
            </div>
        </Modal>
    )    
}